import React, { Component } from "react"

export default class LoginForm extends Component {
    onSubmit = event => {
        event.preventDefault()
        this.props.requestForgotten(this.emailInput.value)
    }

    render() {
        return (
            <form id="resetForm" name="resetForm" onSubmit={this.onSubmit}>
                <div className="form-header">
                    Please enter the registered email address you would like to
                    recover credentials for:
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        ref={input => (this.emailInput = input)}
                        className="form-control"
                        name="email"
                        placeholder="Email address"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="btn btn-info btn-login margin-bottom--20"
                    name="submit"
                >
                    Retrieve
                </button>
                <button
                    type="button"
                    className="btn btn-cancel margin-bottom--20"
                    name="cancel"
                    onClick={this.props.toggleForm("loginForm")}
                >
                    Cancel
                </button>
            </form>
        )
    }
}
